import zealPhoto from '../../../img/renaissance-new/stories/zeal.webp';
import harshitPhoto from '../../../img/renaissance-new/stories/harshit.webp';
import chetanPhoto from '../../../img/renaissance-new/stories/chetan.webp';
import kunalPhoto from '../../../img/renaissance-new/stories/kunal.webp';
import dakshPhoto from '../../../img/renaissance-new/stories/daksh.webp';
import gurinderPhoto from '../../../img/renaissance-new/stories/gurinder.webp';
import yagyaPhoto from '../../../img/renaissance-new/stories/yagya.webp';
import praveenPhoto from '../../../img/renaissance-new/stories/praveen.webp';
import ashutoshPhoto from '../../../img/renaissance-new/stories/ashutosh.webp';

import video1 from '../../../img/renaissance-new/stories/v1.webp';
import video2 from '../../../img/renaissance-new/stories/v2.webp';
import video3 from '../../../img/renaissance-new/stories/v3.webp';

import amazonLogo from '../../../img/successStories/amazon.svg';
import googleLogo from '../../../img/successStories/google.svg';
import codeNationLogo from '../../../img/successStories/Codenation-logo.svg';
import turvoLogo from '../../../img/turvo-logo-img.svg';
import oracleLogo from '../../../img/logo-oracle.svg';

export const IMPACT_COLUMN_1 = [
  {
    type: 'quote',
    title: '“BUILT REAL PROBLEM-SOLVING SKILLS”',
    quote:
      "Whatever I am today, I owe it to Programming Pathshala and their life-changing course 'Renaissance.' I think it is pretty much all we need to build problem-solving skills.",
    name: 'Zeal Vagadia',
    role: 'SDE',
    company: 'Amazon',
    avatar: zealPhoto,
    companyLogo: amazonLogo,
  },
  {
    type: 'quote',
    title: '“BEST VALUE FOR MONEY”',
    quote:
      'Programming Pathshala is the best course. You don’t know what you get until you enrol and start preparing. It is the most value for money course available online and you’re getting “Gold in the price of Silver”',
    name: 'Harshit Jaiswal',
    role: 'SDE',
    company: 'Turvo',
    avatar: harshitPhoto,
    companyLogo: turvoLogo,
  },
  { type: 'video', thumbnail: video1, videoUrl: 'https://youtu.be/Km3-T96zgqA' },
  {
    type: 'quote',
    title: '“MASTERED LOW-LEVEL DESIGN”',
    quote:
      'Thanks to the remarkable course - Low Level Design, I am now skilled at navigating complex architectural challenges, evaluating multiple solutions with precision, and making informed decisions by weighing their respective advantages and disadvantages.',
    name: 'Chetan Verma',
    role: 'SDE',
    company: 'CodeNation',
    avatar: chetanPhoto,
    companyLogo: codeNationLogo,
  },
];

export const IMPACT_COLUMN_2 = [
  { type: 'video', thumbnail: video2, videoUrl: 'https://youtu.be/ygPGUXe9SGc' },
  {
    type: 'quote',
    title: '“CRACKED MY FIRST LLD ROUND”',
    quote:
      "Thank you so much for the awesome course. I am feeling very much comfortable with LLD questions now. I was able to apply the right design pattern at the right place in one of my interviews with ClearTrip. Vivek sir has been very helpful throughout my journey, and I am very grateful. This course helped me crack the first LLD round of ClearTrip!",
    name: 'Kunal Singhal',
    role: 'SDE',
    company: 'Google',
    avatar: kunalPhoto,
    companyLogo: googleLogo,
  },
  {
    type: 'quote',
    title: '“BUILT THE CONFIDENCE TO CRACK ORACLE”',
    quote:
      'After realizing the need to sharpen my DSA skills, joining Programming Pathshala felt like a homecoming. The personal mentorship helped refine my problem-solving approach, and the mock interviews built my confidence, leading to a role at Oracle Cloud Infrastructure.',
    name: 'Dakshi Suri',
    role: 'SDE',
    company: 'Oracle',
    avatar: dakshPhoto,
    companyLogo: oracleLogo,
  },
  {
    type: 'quote',
    title: '“CONFIDENCE TO CRACK THE DREAM COMPANY”',
    quote:
      'The "Renaissance" course is very well structured, and has everything to instil the skills and confidence in one to crack their dream company. The content, the platform, the 1:1 guidance, and everything is great here.',
    name: 'Gurinder Kaur',
    role: 'SDE',
    company: 'Amazon',
    avatar: gurinderPhoto,
    companyLogo: amazonLogo,
  },
];

export const IMPACT_COLUMN_3 = [
  {
    type: 'quote',
    title: '“THE GUIDANCE I NEEDED”',
    quote:
      'I have always been a person who wanted a teacher and some proper guidance, and I think that Programming Pathshala is best for it.',
    name: 'Yagya Modi',
    role: 'SDE',
    company: 'Google',
    avatar: yagyaPhoto,
    companyLogo: googleLogo,
  },
  {
    type: 'quote',
    title: '“FROM TIER-3 TO ORACLE”',
    quote:
      'Coming from a Tier-3 college with limited exposure, Programming Pathshala changed everything for me. The community support and mentorship helped me improve my problem-solving skills and land a Full Stack Developer role at Oracle. Consistency and progress paved the way for my success.',
    name: 'Praveen Krishna',
    role: 'SDE',
    company: 'Oracle',
    avatar: praveenPhoto,
    companyLogo: oracleLogo,
  },
  {
    type: 'quote',
    title: '“STRUCTURE THAT KEPT ME MOVING”',
    quote:
      'The course has well-structured lectures, weekend live classes, and comprehensive problems, covered all possible variations. There was constant support from Vivek Sir and Anoop Sir who were always accessible, and were a source of inspiration throughout the journey.',
    name: 'Ashutosh Amrutkar',
    role: 'SDE',
    company: 'Amazon',
    avatar: ashutoshPhoto,
    companyLogo: amazonLogo,
  },
  { type: 'video', thumbnail: video3, videoUrl: 'https://youtu.be/yj_SxTKPvtw' },
];

// Mobile shows a shorter, single-column curated list (no video cards) in a
// fixed order per the Figma mobile spec, rather than the full masonry.
const ALL_QUOTES = [...IMPACT_COLUMN_1, ...IMPACT_COLUMN_2, ...IMPACT_COLUMN_3].filter(
  (item) => item.type === 'quote',
);
const byName = (name) => ALL_QUOTES.find((item) => item.name === name);

export const IMPACT_VIDEOS = [...IMPACT_COLUMN_1, ...IMPACT_COLUMN_2, ...IMPACT_COLUMN_3].filter(
  (item) => item.type === 'video',
);

export const IMPACT_MOBILE = [
  'Kunal Singhal',
  'Yagya Modi',
  'Zeal Vagadia',
  'Ashutosh Amrutkar',
  'Chetan Verma',
].map(byName);
